<template>
  <transition name="slide-fade">
    <slot></slot>
  </transition>
</template>

<style scoped>
.caret {
  cursor: pointer;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: max-height 1.5s ease, opacity 0.5s ease, transform 2.0s ease;
}

.slide-fade-enter-from, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  max-height: 0;
}

.slide-fade-enter-to, .slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

.answer-wrapper {
  overflow: hidden;
}
</style>
